<div class="dashboard w-full admin-compact-page">
  <app-breadcrumb></app-breadcrumb>
  <section class="module-landing-hero" aria-label="User Management overview">
    <div class="module-landing-hero__content">
      <div class="module-landing-hero__eyebrow">ADMINISTRATION</div>
      <h1>User Management</h1>
      <p>Manage user access, profile attributes, role assignment, lifecycle state, and administrative actions from a focused control page.</p>
    </div>
    <div class="module-landing-hero__chips">
      <div class="module-landing-hero__chip"><span>Total Users</span><strong>{{ pagination.length || 0 }}</strong></div>
      <div class="module-landing-hero__chip"><span>Active Filter</span><strong>{{ selectedStatus ? (selectedStatus | titlecase) : 'All' }}</strong></div>
      <div class="module-landing-hero__chip"><span>Page Size</span><strong>{{ pagination.limit || 10 }}</strong></div>
    </div>
  </section>

  <div class="admin-toolbar">
    <mat-form-field>
      <input
        matInput
        placeholder="Search users"
        [formControl]="searchForm.get('search')"
        (keyup)="onSearch($event)"
      />
      <button mat-icon-button matSuffix aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field>
      <mat-select
        [(ngModel)]="selectedStatus"
        (ngModelChange)="onStatusChange($event)"
        placeholder="User Status"
      >
        <mat-option value="">All statuses</mat-option>
        <mat-option *ngFor="let status of userStatusList" [value]="status">
          {{ status | titlecase }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <span class="admin-toolbar__spacer"></span>
    <button
      [disabled]="!hasDetailedPerm('User_Management', 'Create', 'read')"
      class="app-button"
      mat-flat-button
      (click)="createUser()"
    >
      <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
      <span class="ml-2 mr-1">Create User</span>
    </button>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="serial">
        <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
        <td mat-cell *matCellDef="let role; let i = index">
          {{ i + 1 + pagination.page * pagination.limit }}
        </td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
        <td mat-cell *matCellDef="let user">{{ user.username || '--' }}</td>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
        <td mat-cell *matCellDef="let user">{{ user.firstName || '--' }}</td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
        <td mat-cell *matCellDef="let user">{{ user.lastName || '--' }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let user">{{ user.email || '--' }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Role</th>
        <td mat-cell *matCellDef="let user">{{ user.role || '--' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let user">
          <span class="px-2 rounded-full {{ getBadgeClass(user.status) }}">
            {{ user.status | titlecase }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let user">
          <button mat-icon-button color="accent" (click)="viewDetail(user)">
            <mat-icon>remove_red_eye</mat-icon>
          </button>
          <button
            [disabled]="!hasDetailedPerm('User_Management', 'Edit', 'read')"
            mat-icon-button
            (click)="editRole(user)"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <button
            *ngIf="user.status !== 'archived'"
            mat-icon-button
            matTooltip="Archive user"
            matTooltipPosition="above"
            (click)="deleteUser(user)"
            [disabled]="!hasDetailedPerm('User_Management', 'Delete', 'read')"
          >
            <mat-icon class="app-text">archive</mat-icon>
          </button>
          <button
            *ngIf="user.status === 'archived'"
            mat-icon-button
            matTooltip="Unarchive user"
            matTooltipPosition="above"
            (click)="deleteUser(user, false)"
          >
            <mat-icon class="app-text">unarchive</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-10 text-gray-500" [attr.colspan]="displayedColumns.length">
          {{ isLoading ? 'Loading users...' : 'No users found for the selected filters.' }}
        </td>
      </tr>
    </table>
    <div class="flex justify-end bg-white">
      <mat-paginator
        [length]="pagination.length"
        [pageSize]="10"
        [pageIndex]="pagination.page"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="onPaginateChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
